import { IRouteModel } from '../interface/common';
import {
  HomeLandingPage,
  FeaturesLandingPage,
  PricingLandingPage,
  AboutLandingPage,
  PrivacyPolicyLandingPage,
  TermsOfServiceLandingPage,
  CookiePolicyLandingPage,
} from '~/pages/landing';
import { landingRoute } from '../constants/routes';

export { landingRoute };

export const publicLandingRoutes: IRouteModel[] = [
  {
    path: landingRoute.home,
    component: HomeLandingPage,
  },
  {
    path: landingRoute.features,
    component: FeaturesLandingPage,
  },
  {
    path: landingRoute.pricing,
    component: PricingLandingPage,
  },
  {
    path: landingRoute.about,
    component: AboutLandingPage,
  },
  {
    path: landingRoute.privacyPolicy,
    component: PrivacyPolicyLandingPage,
  },
  {
    path: landingRoute.termsOfService,
    component: TermsOfServiceLandingPage,
  },
  {
    path: landingRoute.cookiePolicy,
    component: CookiePolicyLandingPage,
  },
];
